import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, IconButton, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';

import { LeaderboardScoreFragment } from 'api';
import { UserAvatar } from 'components';

import Change from './Change';
import UserPointDialog from './UserPointDialog';

interface Props {
  userScore: LeaderboardScoreFragment;
}

const UserScore: FC<Props> = ({ userScore }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { user, ranking, score, position_change } = userScore;

  function getRanking(currentRanking: LeaderboardScoreFragment['ranking']) {
    return <Typography variant="subtitle2">{currentRanking}</Typography>;
  }

  return (
    <Fragment>
      <Divider sx={{ marginTop: 3, marginBottom: 3 }} />
      <Grid container spacing={2} alignItems="center">
        <Grid>
          <UserAvatar user={user} size={50} />
        </Grid>
        <Grid xs>
          <Typography variant="h6">{user.full_name}</Typography>
          <Typography>{user.job_title}</Typography>
        </Grid>
        <Grid xs={1}>
          <Typography color="textSecondary">{t('common:rank')}</Typography>
          <Typography variant="h6">{ranking}</Typography>
        </Grid>
        <Grid xs={1}>
          <Typography color="textSecondary">{t('common:change')}</Typography>
          <Typography variant="h6">{<Change change={position_change} />}</Typography>
        </Grid>
        <Grid xs={1}>
          <Typography color="textSecondary">{t('common:point_plural')}</Typography>
          <Typography variant="h6">{score}</Typography>
        </Grid>
        <Grid>
          <IconButton onClick={() => setOpen(true)} size="large">
            <NotesIcon />
          </IconButton>
          <UserPointDialog
            leaderboardScore={userScore}
            renderRank={getRanking}
            renderChange={change => <Change change={change} />}
            open={open}
            onClose={() => setOpen(false)}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default UserScore;
